import { Tabs, TabsList, TabsTrigger } from "@repo/ui/components/tabs";
import { createFileRoute, Outlet, useLocation, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/users")({
  component: RouteComponent,
});

const navItems = [
  { label: "Manage users", to: "/users/manage" },
  { label: "Email allow-list", to: "/users/allow-list" },
] as const;

function RouteComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = location.pathname.endsWith("/allow-list")
    ? "/users/allow-list"
    : "/users/manage";

  return (
    <div className="flex h-full min-h-0 flex-col gap-4 p-4">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">Users</h1>
        <p className="text-sm text-muted-foreground">
          Manage admin accounts and control which emails can sign in.
        </p>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={(value) => {
          void navigate({
            to: value === "/users/allow-list" ? "/users/allow-list" : "/users/manage",
          });
        }}
      >
        <TabsList>
          {navItems.map((item) => (
            <TabsTrigger key={item.to} value={item.to}>
              {item.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      <Outlet />
    </div>
  );
}
